import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import {TimeCategoryOption } from "../../interfaces/queryBuilderInterfaces";


interface DropdownOption {
    value: string | TimeCategoryOption;
    label: string;
}

// Define the props for the Dropdown component
interface DropdownProps {
    id: string;
    label?: string;
    options: DropdownOption[]; // Array of dropdown options
    selectedValue: string | TimeCategoryOption; // The selected option
    onChange: (value: string | TimeCategoryOption) => void;
}

// Define styled components using Emotion
const DropdownContainer = styled.div`
`;

const DropdownLabel = styled.label`
    color: #1A1A1A;
    text-align: left;
    font-weight:bold;
`;

const DropdownSelect = styled.select`
    color: #1A1A1A;
    text-align: left;
    border: 1px solid #CCCCCC;
    width: 100%;
    font-size: 14px;

    &:focus {
        border: 1px solid #5C5C5C;
    }
`;

const DropdownOption = styled.option`
    background: #FFFFFF 0% 0% no-repeat padding-box;
`;

export const TimePeriodDropdown: React.FC<DropdownProps> = ({id, label, options, selectedValue, onChange }) => {
    // State to hold the selected option
    //const [selectedOption, setSelectedOption] = useState<string>(selectedValue);
    const [selectedOption, setSelectedOption] = useState<string | TimeCategoryOption>(selectedValue);
    // Effect to set the first item as the default selected value


    // Handle change event
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = event.target.value;
        //setSelectedOption(newValue);
        //onChange(newValue);
        const selectedOptionObject = options.find(option => 
            typeof option.value === 'string' ? option.value === newValue : (option.value as TimeCategoryOption).name === newValue
        );

        // Set the selected option state
        setSelectedOption(selectedOptionObject ? selectedOptionObject.value : newValue);
        // Call the onChange handler with the selected value
        onChange(selectedOptionObject ? selectedOptionObject.value : newValue);
    };
    return (
        <DropdownContainer>
            <DropdownLabel htmlFor={id}>{label}</DropdownLabel>
            <DropdownSelect id={id} value={typeof selectedOption === 'object' ? (selectedOption as TimeCategoryOption).name : selectedOption} onChange={handleChange}>
                {options.map(option => (
                    <DropdownOption 
                        key={typeof option.value === 'object' ? (option.value as TimeCategoryOption).name : option.value} 
                        value={typeof option.value === 'object' ? (option.value as TimeCategoryOption).name : option.value}
                    >
                        {option.label}
                    </DropdownOption>
                ))}
            </DropdownSelect>
        </DropdownContainer>
    );
};
